import { render } from "./noticeBell.vue?vue&type=template&id=ad11a284"
import script from "./noticeBell.vue?vue&type=script&lang=js"
export * from "./noticeBell.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__